import React from "react";

const CakeIcon = ({ width }) => {
  return (
    <svg
      viewBox='0 0 64 64'
      width={width}
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      role='img'
      className='iconify iconify--emojione'
      preserveAspectRatio='xMidYMid meet'
      fill='#000000'
    >
      <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {" "}
        <ellipse cx='32' cy='49.4' rx='30' ry='12.6' fill='#d0d0d0'>
          {" "}
        </ellipse>{" "}
        <path
          d='M7.7 24.8v22.5C7.7 53 18.6 57.6 32 57.6S56.3 53 56.3 47.4V24.8H7.7z'
          fill='#d3976e'
        >
          {" "}
        </path>{" "}
        <g fill='#ffdd7d'>
          {" "}
          <path d='M56.3 31.4c-.1 4-15.4 8.4-24.3 8.4S7.8 35.4 7.7 31.4v6.1c12.5 9 36.1 9 48.6 0v-6.1'>
            {" "}
          </path>{" "}
          <path d='M56.3 41c-.1 4-15.4 8.4-24.3 8.4S7.8 45 7.7 41v6.1c12.5 9 36.1 9 48.6 0V41'>
            {" "}
          </path>{" "}
        </g>{" "}
        <path
          d='M7.7 24.8v16.9c0 .9.8 1.7 1.9 1.7c1 0 1.9-.7 1.9-1.7v-3.9c0-1.2 1.1-2.2 2.5-2.2s2.5 1 2.5 2.2v4.8c0 1.4 1.3 2.6 2.9 2.6s2.9-1.1 2.9-2.6v-4.9c0-1.3 1.2-2.3 2.6-2.3c1.4 0 2.6 1 2.6 2.3v3.1c0 .7.6 1.3 1.5 1.3c.8 0 1.5-.6 1.5-1.3v-2.5c0-.9.8-1.7 1.9-1.7c1 0 1.9.7 1.9 1.7v4.2c0 1.4 1.3 2.6 2.9 2.6c1.6 0 2.9-1.1 2.9-2.6v-4.7c0-1.2 1.1-2.2 2.5-2.2s2.5 1 2.5 2.2v3.5c0 .7.7 1.3 1.5 1.3s1.5-.6 1.5-1.3v-2.4c0-.6.6-1.1 1.3-1.1c.7 0 1.3.5 1.3 1.1v3.7c0 1.4 1.3 2.6 2.9 2.6c1.6 0 2.9-1.1 2.9-2.6V24.9l-48.8-.1'
          fill='#a80038'
        >
          {" "}
        </path>{" "}
        <ellipse cx='32' cy='24.8' rx='24.3' ry='10.2' fill='#ff2c68'>
          {" "}
        </ellipse>{" "}
        <path
          d='M14.4 23.8c-.1-6.5 28.7-7.4 28.8-1.6c.1 4.3-18.3 4.5-18.4 1.1c-.1-2.4 11.4-2.5 11.4-.7s-9.3 2.1-7.1-.2c-3.7 2.8 8.1 2.9 8 .3c-.1-3-13.9-2.6-13.9.5c.1 4.6 21.4 4.1 21.3-1.1c-.1-6.8-32-6.5-31.8 1.6c.2 8.9 31.2 12.1 41.3.8c-13.7 10.4-39.5 5.4-39.6-.7'
          fill='#ffa4a4'
        >
          {" "}
        </path>{" "}
        <path
          d='M11.8 11.6v10.8c0 1.5 3.2 1.3 3.2 0V11.6c0-1.5-3.2-1.5-3.2 0'
          fill='#42ade2'
        >
          {" "}
        </path>{" "}
        <g fill='#428bc1'>
          {" "}
          <path d='M15 12.6l-3.2 1.7v1.9l3.2-1.6z'> </path>{" "}
          <path d='M11.8 19.5v1.8l3.2-1.6v-1.9z'> </path>{" "}
        </g>{" "}
        <path
          d='M15.1 9.2c0 2.5-3.3 2.5-3.3 0c0-.8 1.7-3.4 1.7-3.4s1.6 2.6 1.6 3.4'
          fill='#ff8b00'
        >
          {" "}
        </path>{" "}
        <path
          d='M14.3 10c0 1.4-1.7 1.4-1.7 0c0-.4.8-1.7.8-1.7s.9 1.3.9 1.7'
          fill='#fff033'
        >
          {" "}
        </path>{" "}
        <path
          d='M30.6 7.2v9.4c0 1.5 2.8 1.2 2.8 0V7.2c0-1.5-2.8-1.5-2.8 0'
          fill='#42ade2'
        >
          {" "}
        </path>{" "}
        <g fill='#428bc1'>
          {" "}
          <path d='M33.4 8l-2.8 1.5v1.7l2.8-1.5z'> </path>{" "}
          <path d='M30.6 14v1.6l2.8-1.4v-1.6z'> </path>{" "}
        </g>{" "}
        <path
          d='M33.4 5c0 2.3-2.9 2.3-2.9 0c0-.7 1.4-3 1.4-3s1.5 2.3 1.5 3'
          fill='#ff8b00'
        >
          {" "}
        </path>{" "}
        <path
          d='M32.7 5.7c0 1.4-1.4 1.4-1.4 0c0-.4.7-1.5.7-1.5s.7 1.1.7 1.5'
          fill='#fff033'
        >
          {" "}
        </path>{" "}
        <path
          d='M48.9 11.6v10.8c0 1.5 3.2 1.3 3.2 0V11.6c0-1.5-3.2-1.5-3.2 0'
          fill='#42ade2'
        >
          {" "}
        </path>{" "}
        <g fill='#428bc1'>
          {" "}
          <path d='M52.1 12.6l-3.2 1.7v1.9l3.2-1.7z'> </path>{" "}
          <path d='M48.9 19.5v1.8l3.2-1.7v-1.8z'> </path>{" "}
        </g>{" "}
        <path
          d='M52.2 9.2c0 2.5-3.3 2.5-3.3 0c0-.8 1.7-3.4 1.7-3.4s1.6 2.5 1.6 3.4'
          fill='#ff8b00'
        >
          {" "}
        </path>{" "}
        <path
          d='M51.4 9.9c0 1.4-1.7 1.4-1.7 0c0-.4.8-1.7.8-1.7s.9 1.3.9 1.7'
          fill='#fff033'
        >
          {" "}
        </path>{" "}
        <path
          d='M20 18.3v13.1c0 1.7 3.9 1.3 3.9 0V18.3c0-1.6-3.9-1.6-3.9 0'
          fill='#9fe4ff'
        >
          {" "}
        </path>{" "}
        <g fill='#42ade2'>
          {" "}
          <path d='M23.9 19.6L20 21.5v2.4l3.9-2z'> </path>{" "}
          <path d='M20 27.8V30l3.9-1.9v-2.2z'> </path>{" "}
        </g>{" "}
        <path
          d='M24 15.4c0 2.7-4 2.7-4 0c0-1 2-4.2 2-4.2s2 3.2 2 4.2'
          fill='#ff8b00'
        >
          {" "}
        </path>{" "}
        <path
          d='M23 16.3c0 1.5-2 1.5-2 0c0-.5 1-2.1 1-2.1s1 1.6 1 2.1'
          fill='#fff033'
        >
          {" "}
        </path>{" "}
        <path
          d='M40 18.3v13.1c0 1.7 3.9 1.3 3.9 0V18.3c0-1.7-3.9-1.7-3.9 0'
          fill='#9fe4ff'
        >
          {" "}
        </path>{" "}
        <g fill='#42ade2'>
          {" "}
          <path d='M43.9 19.5l-3.9 2v2.3l3.9-1.9z'> </path>{" "}
          <path d='M40 27.8V30l3.9-2v-2.2z'> </path>{" "}
        </g>{" "}
        <path
          d='M44 15.3c0 2.7-4 2.7-4 0c0-1 2-4.2 2-4.2s2 3.3 2 4.2'
          fill='#ff8b00'
        >
          {" "}
        </path>{" "}
        <path
          d='M43 16.3c0 1.5-2 1.5-2 0c0-.5 1-2.1 1-2.1s1 1.6 1 2.1'
          fill='#fff033'
        >
          {" "}
        </path>{" "}
      </g>
    </svg>
  );
};

export default CakeIcon;
